import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBack, arrowBackCircle, bookmark } from 'ionicons/icons';
import { Backbutton, Bookmarkbutton, TopNavContainer } from './InnerPageStyles';
import { useHistory } from 'react-router';
import BookmarkStoryButton from '../BookmarkButton/BookmarkStoryButton';

type TopNavProps = {
	storyId: number;
};
const StoryTopNav: React.FC<TopNavProps> = ({ storyId }) => {
	const history = useHistory();
	return (
		<TopNavContainer>
			<Backbutton>
				<IonIcon
					icon={arrowBack}
					onClick={() => {
						if (window.history.length > 1) {
							history.goBack();
						} else {
							history.replace('/home');
						}
					}}
				/>
			</Backbutton>
			<BookmarkStoryButton storyId={storyId} />
		</TopNavContainer>
	);
};

export default StoryTopNav;
